import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DesktopMenu from "../../common/DesktopMenu/index";
import MobileMenu from "../../common/MobileMenu/index";
import useWindowSize from "../../common/windowSize";
import NewFooter from "../../common/NewFooter";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { publicAPI } from "../../utils/api";
import {
  Background,
  AllProductsTitle,
  CreamTitle,
  TittleWrapper,
  CarouselWrapper,
} from "./styles";
import ProductFullDescription from "./ProductFullDescription";
import BackButton from "../Products/BackButton";
import Product from "../Products/Product";
import Carousel from "react-material-ui-carousel";
import { chunk } from "lodash";

const ProductPage = () => {
  const { groupId, productId } = useParams();
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [groupName, setGroupName] = useState();
  const [groupNameFirstWord, setGroupNameFirstWord] = useState();
  const [groupNameRestWords, setGroupNameRestWords] = useState();
  const [loading, setLoading] = useState(false);
  const [singleProduct, setSingleProduct] = useState({});
  const [chunked4Products, setChunked4Products] = useState([]);
  const [chunked2Products, setChunked2Products] = useState([]);

  const getProductsFromGroup = async (id) => {
    setLoading(true);

    try {
      const productsResponse = await publicAPI.get(
        `/public/bacchus/product?product_group_id=${id}`
      );
      setChunked4Products(chunk(productsResponse.data, 4));
      setChunked2Products(chunk(productsResponse.data, 2));
      const groupNameResponse = await publicAPI.get(
        `/public/bacchus/productgroup/${id}`
      );
      setGroupName(groupNameResponse.data.name);
      setGroupNameFirstWord(
        groupNameResponse.data.name.substr(
          0,
          groupNameResponse.data.name.indexOf(" ")
        )
      );
      setGroupNameRestWords(
        groupNameResponse.data.name.substr(
          groupNameResponse.data.name.indexOf(" ")
        )
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  const getProductById = async (id) => {
    setLoading(true);

    try {
      const productResponse = await publicAPI.get(
        `/public/bacchus/product/${id}`
      );
      setSingleProduct(productResponse.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  };

  useEffect(() => {
    getProductsFromGroup(groupId);
    getProductById(productId);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
  }, [size]);

  return (
    <React.Fragment>
      <Background>
        {mobileMenu ? <MobileMenu /> : <DesktopMenu />}
        <TittleWrapper>
          <BackButton />
          <AllProductsTitle>
            {groupName?.includes(" ") ? groupNameFirstWord : groupName}
            {groupName?.includes(" ") && (
              <CreamTitle>{groupNameRestWords}</CreamTitle>
            )}
          </AllProductsTitle>
        </TittleWrapper>
        <ProductFullDescription
          product={singleProduct}
          setSingleProduct={setSingleProduct}
        />
        <CarouselWrapper>
          <Carousel
            fullHeightHover={false}
            autoPlay={true}
            stopAutoPlayOnHover={true}
            swipe={true}
            animation="slide"
          >
            {(size.width < 800 ? chunked2Products : chunked4Products).map(
              (products, index) => (
                <div
                  key={index + Math.random()}
                  style={{ display: "flex", gap: "10px" }}
                >
                  {products.map((product) => (
                    <Product
                      key={product.id}
                      item={product}
                      groupId={product.productGroupId}
                      setSingleProduct={setSingleProduct}
                      carousel={true}
                    />
                  ))}
                </div>
              )
            )}
          </Carousel>
        </CarouselWrapper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default ProductPage;
